export default __webpack_public_path__ + "5ae26639b613d023b608ad27eaa09050.png";